import { companyTypeService } from '../../helpers/services/companyType.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const TYPE_MODULE = 'companyType';

// define action 
export const GET_ALL_TYPES = 'getAllTypes';
export const GET_TYPE = 'getType';
export const UPDATE_TYPE = 'updateType';
export const CREATE_TYPE = 'createType';
export const UPDATE_TYPE_STATUS = 'updateTypeStatus';

// define mutation
const SUCCESS = "commonSuccess";
const SUCCESS_WITHOUT_REDIRECT = "successWithoutRedirect";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_TYPES_REQUEST = "getAllTypes";
const GET_TYPE_REQUEST = "getType";

export const actions = {
    // eslint-disable-next-line no-unused-vars
     [GET_ALL_TYPES]({ commit }, { filter }) {
         companyTypeService
            .getAllTypes(filter)
            .then(
                (result) => {
                    commit(GET_ALL_TYPES_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
     [GET_TYPE]({ commit }, { id }) {
        companyTypeService
            .getType(id)
            .then(
                (result) => {
                    commit(GET_TYPE_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_TYPE]({ commit }, { data }) {
        commit(REQUEST)
        companyTypeService
            .updateType(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.companyType')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_TYPE]: async ({ commit }, { redirect, data }) => {
        commit(REQUEST);
        var return_result = [];
        try {
            var result = await companyTypeService.createType(data);
            return_result['type_uuid'] = result.data.uuid;
            const message = i18n.t("message.createXSuccess", [i18n.t('module.companyType')]);
            sharedHelper.alertSuccessMessage(message);

            if (redirect) {
                commit(SUCCESS);
            } else {
                commit(SUCCESS_WITHOUT_REDIRECT);
            }

            return_result['result'] = true

        } catch (error) {
            const message = sharedHelper.getErrorMessage(error);
            sharedHelper.alertErrorMessage(message, error.response?.data?.code);
            commit(FAILURE);
            return_result['result'] = false
        }

        return return_result;

    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_TYPE_STATUS]({ dispatch }, { filter, data }) {
        companyTypeService
            .updateTypeStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_TYPES, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },


};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Company-type-listing" });
    },
    [SUCCESS_WITHOUT_REDIRECT](state) {
        state.status = {};
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_TYPES_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                isActive: o.is_active,
                createdBy: o.created_by,
                logo: o.logo,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
                
            }
        })
    },
    [GET_TYPE_REQUEST](state, data) {
        let o = data.data
        
        state.details = {
            uuid: o.uuid,
            name: o.name,
            isActive: o.is_active,
            createdBy: o.created_by,
            logo: o.logo,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
        }
    }
}


